/**
 * skinnr.ts - Skinnr (Themes & Appearance) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1436 [pending] danielbeer: Added package metadata
 * - 251023_1854 [pending] danielbeer: Initial creation
 */

export const skinnrModule = {
  id: 'system-skinnr',
  name: 'Themes & Appearance',
  icon: '🎨',
  category: 'modules',
  order: 1,
  
  // Package metadata for info panel
  packageInfo: {
    name: '@opcentral/skinnr',
    version: '0.2.0+251021002750',
    displayVersion: '0.2.0',
    description: 'Theme and skin management system for OpCentral',
    status: 'implemented',
    implementationProgress: 100,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      'react': '^18.2.0',
      '@mui/material': '^5.14.0',
      '@mui/icons-material': '^5.14.0',
      '@emotion/react': '^11.11.0',
      '@emotion/styled': '^11.11.0',
      'notistack': '^3.0.1'
    },
    keywords: ['theming', 'skins', 'appearance'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    currentTheme: {
      type: 'select',
      label: 'Theme',
      description: 'Choose your preferred theme',
      defaultValue: 'light',
      options: [
        { label: 'Light', value: 'light' },
        { label: 'Dark', value: 'dark' },
        { label: 'Auto (System)', value: 'auto' },
        { label: 'High Contrast', value: 'high-contrast' }
      ]
    },
    
    accentColor: {
      type: 'color',
      label: 'Accent Color',
      description: 'Primary accent color for the interface',
      defaultValue: '#3b82f6'
    },
    
    fontSize: {
      type: 'select',
      label: 'Font Size',
      description: 'Base font size for the interface',
      defaultValue: 'medium',
      options: [
        { label: 'Small', value: 'small' },
        { label: 'Medium', value: 'medium' },
        { label: 'Large', value: 'large' },
        { label: 'Extra Large', value: 'extra-large' }
      ]
    },
    
    compactMode: {
      type: 'boolean',
      label: 'Compact Mode',
      description: 'Use tighter spacing for more content on screen',
      defaultValue: false
    },
    
    animations: {
      type: 'boolean',
      label: 'Enable Animations',
      description: 'Show smooth transitions and animations',
      defaultValue: true
    },
    
    reducedMotion: {
      type: 'boolean',
      label: 'Reduce Motion',
      description: 'Minimize animations for accessibility',
      defaultValue: false
    }
  }
};

export default skinnrModule;
